import { render, staticRenderFns } from "./SearchMessageList.vue?vue&type=template&id=7bf1a134&"
import script from "./SearchMessageList.vue?vue&type=script&lang=js&"
export * from "./SearchMessageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports